/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IndustryExpertiseResource
 */
export interface IndustryExpertiseResource {
    /**
     * 
     * @type {string}
     * @memberof IndustryExpertiseResource
     */
    humanId: string;
    /**
     * 
     * @type {string}
     * @memberof IndustryExpertiseResource
     */
    label: string;
}

/**
 * Check if a given object implements the IndustryExpertiseResource interface.
 */
export function instanceOfIndustryExpertiseResource(value: object): value is IndustryExpertiseResource {
    if (!('humanId' in value) || value['humanId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function IndustryExpertiseResourceFromJSON(json: any): IndustryExpertiseResource {
    return IndustryExpertiseResourceFromJSONTyped(json, false);
}

export function IndustryExpertiseResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndustryExpertiseResource {
    if (json == null) {
        return json;
    }
    return {
        
        'humanId': json['humanId'],
        'label': json['label'],
    };
}

export function IndustryExpertiseResourceToJSON(value?: IndustryExpertiseResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'humanId': value['humanId'],
        'label': value['label'],
    };
}

